import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { sendSignInLinkToEmail, signInWithEmailLink, updateProfile } from "firebase/auth";
import { auth } from "../../../../firebase/firebase";
import { useEffect, useState } from "react";
// import { SignupContext } from "../../../../context/SignupContext";
// import * as Yup from "yup";
import Button from "../../../../components/Button";
import Loader from "../../../../components/Loader";
import { createUser } from "../../../../api/accounts/userServices";
import { useAuth } from "../../../../context/AuthContext";
import { BASE_URL } from "../../../../config";

const Step3 = () => {
  // const authContext = useAuth();
  const [loading, setLoading] = useState(auth.currentUser?.emailVerified === undefined);
  const [isEmailVerified, setIsEmailVerified] = useState(auth.currentUser?.emailVerified);
  const [email, setEmail] = useState<string | null>(null);

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const resendLink = async (e: React.FormEvent) => {
    e.preventDefault();

    let email = searchParams.get("email") ?? window.localStorage.getItem("emailForSignIn");
    let fname = searchParams.get("fname") ?? window.localStorage.getItem("firstName") ?? "";
    let lname = searchParams.get("lname") ?? window.localStorage.getItem("lastName") ?? "";
    if (email) {
      const actionCodeSettings = {
        // url: `${BASE_URL}/signup/verifyEmail?email=${email}`,
        url: `${BASE_URL}/signup/verifyEmail?email=${email}&fname=${fname}&lname=${lname}`,
        handleCodeInApp: true,
      };
      sendSignInLinkToEmail(auth, email, actionCodeSettings)
        .then(() => {
          navigate("../verify");
        })
        .catch(error => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode, errorMessage);
        });
    }
  };

  // useEffect(() => {
  //   console.log("Email verified: ", isEmailVerified);
  //   if (isEmailVerified && loading) {
  //     setLoading(false);
  //   }
  // }, [isEmailVerified, loading]);

  // const verifyAndUpdate = async (email: string, firstName: string, lastName: string) => {
  //   console.log("called verifyAndUpdate");
  //   try {
  //     const userCred = await signInWithEmailLink(auth, email, window.location.href);
  //     await updateProfile(userCred.user, {
  //       displayName: firstName + " " + lastName,
  //     });
  //     await createUser(userCred.user.uid, { email, firstName, lastName });
  //     console.log(auth.currentUser?.emailVerified);
  //     setIsEmailVerified(true);
  //     setLoading(false);
  //     console.log("success verifyAndUpdate ");
  //     setVerifying(false);
  //   } catch (err) {
  //     console.log("error verifyAndUpdate ");
  //     console.log(JSON.stringify(err));
  //     setIsEmailVerified(false);
  //     setLoading(false);
  //     setVerifying(false);
  //   }
  // };

  // useEffect(() => {
  //   if (isSignInWithEmailLink(auth, window.location.href)) {
  //     let email = window.localStorage.getItem("emailForSignIn");
  //     if (!email) {
  //       email = window.prompt("Please provide your email for confirmation");
  //     }
  //     setEmail(email);
  //   } else {
  //     setLoading(false);
  //   }
  //   return () => {};
  // }, []);

  // useEffect(() => {
  //   if (!email && authContext?.auth && isSignInWithEmailLink(authContext?.auth, window.location.href)) {
  //     let mail = window.localStorage.getItem("emailForSignIn");
  //     if (!mail) {
  //       mail = window.prompt("Please provide your email for confirmation");
  //     }
  //     console.log("set email called" + email);
  //     setEmail(mail);
  //   }
  //   // else {
  //   //   setLoading(false);
  //   // }
  //   // return () => {};
  // }, [authContext?.auth, email]);

  useEffect(() => {
    const verifyAndUpdate = async (email: string, firstName: string, lastName: string) => {
      console.log("called verifyAndUpdate");
      try {
        const userCred = await signInWithEmailLink(auth, email, window.location.href);
        setIsEmailVerified(true);
        await updateProfile(userCred.user, {
          displayName: firstName + " " + lastName,
        });
        await createUser(userCred.user.uid, { email, firstName, lastName });
        console.log(auth.currentUser?.emailVerified);
        console.log("success verifyAndUpdate ");
      } catch (err) {
        console.log("error verifyAndUpdate ");
        console.log(JSON.stringify(err));
        isEmailVerified ? setIsEmailVerified(true) : setIsEmailVerified(false);
      } finally {
        setLoading(false);
      }
    };
    // if (email) {
    // console.log("set email called" + email);

    if (auth.currentUser?.emailVerified) {
      setLoading(false);
      return;
    }
    let mail = searchParams.get("email") ?? window.localStorage.getItem("emailForSignIn");
    if (!mail) {
      mail = window.prompt("Please provide your email for confirmation");
    }

    let firstName = searchParams.get("fname") ?? window.localStorage.getItem("firstName") ?? "";
    let lastName = searchParams.get("lname") ?? window.localStorage.getItem("lastName") ?? "";
    if (mail) {
      console.log("###calling very and update ####");
      verifyAndUpdate(mail, firstName, lastName);
    }
    return () => {
      console.log("unmounitng");
    };

    // }
  }, [isEmailVerified]);

  return (
    <>
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Email verification.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Sign Up</div>
                </div>
                <div className="flex justify-center w-full px-[30px] mb-[30px]">
                  <div className=" bg-skseparatorgray w-full rounded-full h-[5px]">
                    <div className=" bg-skgreen h-[5px] rounded-full" style={{ width: isEmailVerified ? "50%" : "25%" }}></div>
                  </div>
                </div>
                {loading ? (
                  <>
                    <div className="flex flex-col items-start formbodytext">
                      <div className="text-[18px] font-bold text-center mt-[15px] mb-[30px]">Verifying email...</div>
                    </div>
                    <Loader />
                  </>
                ) : (
                  <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                    {isEmailVerified ? (
                      <div className="flex flex-col items-center formbodytext gap-[10px]">
                        <img src={"/images/success.png"} width={80} height={80} alt="Success" className="mt-[15px]" />
                        <div className="text-[18px] font-bold text-center mb-[30px]">Email successfully verified.</div>
                      </div>
                    ) : (
                      <div className="flex flex-col items-start formbodytext">
                        <div className="text-[18px] font-bold text-center mt-[15px] mb-[30px]">Email verification failed.</div>
                        <p className="block mb-2 font-medium text-gray-900 dark:text-white">
                          Try again by either resending the link to the same email address or sign up with a different email.
                        </p>
                      </div>
                    )}
                  </div>
                )}
                <div className="thickseparator"></div>
                {loading ? (
                  ""
                ) : isEmailVerified ? (
                  <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                    <Button to="../password" className="w-full md:w-auto md:min-w-[120px] formprimarybutton">
                      Continue
                    </Button>
                    <Link to="/" className="w-full md:w-auto md:min-w-[120px] formsecondarybutton">
                      Cancel
                    </Link>
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-between w-full p-[30px]  gap-y-[15px]">
                    {/* <Button to="" onClick={resendLink} className="text-[18px] font-bold text-center md:w-auto m-auto">
                      Resend the link?
                    </Button> */}
                    <button className="px-4 py-2 text-black bg-white popup-button-action !h-fit" onClick={resendLink}>
                      Resend the link?
                    </button>

                    <Link to="../" className="w-full text-base md:w-auto md:min-w-[200px] p-[10px] m-auto popup-button-action !h-fit">
                      Sign up with different email?
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step3;
